import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

/**
 * Subtle lift + inner glow on hover for cards.
 */
export const HoverGlow = ({ children, className = "" }) => {
  const reduced = usePreferStaticUI();

  return (
    <motion.div
      className={`relative ${className}`}
      whileHover={reduced ? undefined : { y: -4 }}
      transition={{ duration: 0.35, ease: [0.22, 0.61, 0.36, 1] }}
    >
      <motion.div
        className="pointer-events-none absolute -inset-px rounded-[inherit] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background:
            "radial-gradient(600px circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(158,74,98,0.08), transparent 40%)",
        }}
        aria-hidden="true"
      />
      {children}
    </motion.div>
  );
};

export default HoverGlow;
